import { Navigate, useParams } from 'react-router-dom'
import { Spinner } from 'react-bootstrap'

import { useFeatureFlagService } from 'utils/useFeatureFlagService'

import { SequenceWizardPageV2 } from './sequence-wizard-page-v2'

export function SequenceWizardPage() {
  const featureFlags = useFeatureFlagService()
  const { id } = useParams<{ id: string }>()

  if (featureFlags.isLoading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <Spinner animation="border" />
      </div>
    )
  }

  if (!featureFlags.enableEmailSequencing) {
    return <Navigate to={`/campaigns/${id}`} replace />
  }

  return <SequenceWizardPageV2 />
}
